import React from 'react';
import '../index.css';
import '../styles/AboutPage.css';
// import '../i18n';
// import { useTranslation } from 'react-i18next';
import { useEffect, useState } from "react";
import { useFormSubmit } from '../services/useFormSubmit';
import Jorrit from '../components/team/Jorrit_profile.png';
// import Odylia from '../components/team/Odylia_profile.png';
import George from '../components/team/George_profile.png';
import AnnaMaria from '../components/team/Annamaria_profile.png';
import Priscille from '../components/team/Priscille_profile.png';
import Dennis from '../components/team/Dennis_profile.png';
import Bram from '../components/team/Bram_profile.png';
import Nicolas from '../components/team/Nicolas_profile.png';
import Cas from '../components/team/Cas_profile.jpg';
import Miguel from '../components/team/Miguel_profile.jpg';
import Aicha from '../components/team/Aicha_profile.png';

// Import Swiper components
import 'swiper/css';
import 'swiper/css/autoplay';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';



function AboutPage() {
  // const { t, i18n } = useTranslation();
  const { submitStatus, handleSubmit } = useFormSubmit();
  const [isMobile, setIsMobile] = useState(false); // Add the isMobile state

  useEffect(() => {
    // i18n.changeLanguage(navigator.language);

    // Add resize listener to set isMobile
    const handleResize = () => {
      setIsMobile(window.innerWidth < 720);
    };
    window.addEventListener('resize', handleResize);
    handleResize(); // Set initial value
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const teamMembers = [
    { img: George, name: 'George', title: 'Co-Founder' },
    { img: AnnaMaria, name: 'Anna Maria', title: 'Software Engineer' },
    { img: Dennis, name: 'Dennis', title: 'AI Developer' },
    { img: Priscille, name: 'Priscille', title: 'Business Developer' },
    { img: Bram, name: 'Bram', title: 'AI Developer' },
    { img: Nicolas, name: 'Nicolas', title: 'AI Developer' },
    { img: Cas, name: 'Cas', title: 'Business Developer' },
    { img: Miguel, name: 'Miguel', title: 'Quality Control' },
    { img: Aicha, name: 'Aicha', title: 'Business Developer' },
    { img: Jorrit, name: 'Jorrit', title: 'Co-Founder' },
  ];

  return (
    <div className="about-page">
      <div className="top-hero">
        <div className="hero-grid-item">
          {/* <h4 style={{fontWeight: '400', textAlign: 'center'}}>OUR MISSION</h4> */}
          <h1 style={{fontSize: '4rem', marginBottom: "3vh", marginTop: "3vh", textAlign: 'center'}}>About us</h1>
          <h3 style={{fontWeight: '400', textAlign: 'center'}}>Transforming market research with AI</h3>
        </div>
      </div>

      <div className="hero" style={{backgroundColor: 'var(--secondary-color)', padding: 0, marginTop: '5vh'}}> 
        <div className="aboutus-intro" style={{margin: '6vh 14vw', justifyContent: 'center'}}>
          
          
        <div style={{textAlign: 'center'}}>
          <p style={{lineHeight: '2', letterSpacing: '0.05em', fontWeight: '500', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', borderRadius: '10px', padding: '3vh 2vw', backgroundColor: 'var(--background-color)', maxWidth: '800px', margin: '0 auto'  }}>
            InstantFlows is an innovative AI startup in beta, developing tools to make market research more accessible and efficient. 
            <br/><br/>
            Our platform uses AI to generate synthetic survey responses from virtual personas, helping you quickly test concepts, messages, and ideas without recruiting real participants.  
            <br/><br/>
            Validate your ideas with AI in minutes, not weeks - whether you're exploring pricing options, testing brand messaging, or evaluating product concepts before investing in traditional research.
          </p>
        </div>

        </div>
      </div>

      <div className="team-section">
        <h2>Meet Our Team</h2>
        <style>
          {`
            .team-grid {
              display: grid;
              grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
              gap: 2rem;
              justify-items: center;
              align-items: start;
              margin: 2rem 0;
            }
            .team-member {
              display: flex;
              flex-direction: column;
              align-items: center;
              background: var(--background-color);
              border-radius: 12px;
              
              padding: 1.5rem 1rem;
              width: 100%;
              max-width: 220px;
            }
            .team-member img {
              width: 160px;
              height: 160px;
              object-fit: cover;
              border-radius: 50%;
              margin-bottom: 1rem;
            }
            .team-member-info {
              text-align: center;
            }

            /* Add this Media Query for screens under 720px */
            @media (max-width: 720px) {
              .team-grid {
                display: flex;
                overflow-x: auto;
                gap: 1rem;
                padding: 1rem 0;
                scroll-snap-type: x mandatory;
              }
              .team-member {
                flex: 0 0 auto;
                scroll-snap-align: start;
                width: 80%;
                max-width: none;
              }
              /* Optional: Hide scrollbar for a cleaner look */
              .team-grid::-webkit-scrollbar {
                display: none;
              }
            }

            /* Styling for Swiper slides */
            .swiper-slide {
              display: flex;
              justify-content: center;
              height: 260px !important
            }
          `}
        </style>

        {isMobile ? (
          <Swiper 
            modules={[Autoplay]}
            spaceBetween={10}
            slidesPerView={1}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false
            }}
            speed={1500}>
            {teamMembers.map((member, index) => (
              <SwiperSlide key={index}>
                <div className="team-member">
                  <img src={member.img} alt={member.name} />
                  <div className="team-member-info">
                    <strong>{member.name}</strong>
                    <div>{member.title}</div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div className="team-member" key={index}>
                <img src={member.img} alt={member.name} />
                <div className="team-member-info">
                  <strong>{member.name}</strong>
                  <div>{member.title}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="careers-link"> 
          <p>Interested in working with us? Check out our <a href="/careers">career opportunities</a>.</p>
        </div>
      </div>

      <div className="social-media-section">
        <h3>Connect With Us</h3>
        <div className="social-icons">
          <a href="https://x.com/Instantflows" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/X_icon.svg/768px-X_icon.svg.png" alt="Twitter/X" />
            <span>Twitter</span>
          </a>
          <a href="https://www.linkedin.com/company/instantflows/" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/LinkedIn_logo_initials.png/960px-LinkedIn_logo_initials.png" alt="LinkedIn" />
            <span>LinkedIn</span>
          </a>
          <a href="https://www.instagram.com/instantflows/" target="_blank" rel="noopener noreferrer" className="social-icon">
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png" alt="Instagram" />
            <span>Instagram</span>
          </a>
        </div>
      </div>

      <div className="hero hero-1">
        <h2>Contact us</h2>
        <div className="textbox">
          <p>Leave your question below:</p>
          <form 
            id="interest-form" 
            action="https://script.google.com/macros/s/AKfycbz3X8mRhapnoT9XdfOdhJjXJhO2Q5X0Sz-0FbLsjCK81WlB0rOHiTP1ib3I6acjfC5dmg/exec" 
            method="POST" 
            className="interest-form"
            onSubmit={(e) => handleSubmit(e, 'interest-form')}
          >
            <input type="text" name="Name" placeholder="Your Name" required />
            <input type="email" name="Email" placeholder="Your Email" required />
            <textarea name="question" placeholder="How can we help you today?" required></textarea>
            <button type="submit" className="button">Keep Me Updated</button>
            {submitStatus.message && (
              <div className={submitStatus.isError ? 'error-message' : 'success-message'}>
                {submitStatus.message}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
